<template>
    <div></div>
</template>

<script>
    export default {
        name: "WebixSlider",
        props: ['value'],
        watch:{
            // updates component when the bound value changes
            value:{
                handler:function(value){
                    webix.$$(this.webixId).setValue(value);
                }
            }
        },
        mounted() {
            this.webixId = webix.ui({
                // container and scope are mandatory, other properties are optional
                container: this.$el,
                $scope: this,
                view: "slider",
                value: this.value
            })

            // informs Vue about changed value in case of 2-way data binding
            $$(this.webixId).attachEvent("onChange", function(){
                var value = this.getValue();

                console.log(value);
                // you can use a custom event here
                this.$scope.$emit("input", value)
            });
        },
        destroyed:function(){
            webix.$$(this.webixId).destructor();
        }
    };
</script>

<style scoped>

</style>
